import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=620cbd5f&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620cbd5f')) {
      api.createRecord('620cbd5f', component.options)
    } else {
      api.reload('620cbd5f', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=620cbd5f&", function () {
      api.rerender('620cbd5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25OhcF1KXrnRx/JS/ImageCarousel.vue"
export default component.exports